import AlertsModule from './alerts/alerts.module';
//import BaseState from './base/base.module';
import ComponentsModule from './components/components.module';
import componentDetailsNew from './components_new/components_details_new.module';
import CreateUser from './create_user/create_user.module';
import Forbidden403 from './forbidden_403/forbidden_403.module';
import XrayLogin from './login/login.module';
import notFound404 from './not_found_404/not_found_404.module';
import NotFoundModule from './not_found_404/not_found_404.module';
import PoliciesModule from './policies/policies.module';
import ReportsModule from './reports/reports.module';
import ScanModule from './scan/scan.module';
import ServerError from './server_error/server_error.module';
import SettingsModule from './settings/settings.module';
import WatchersModule from './watchers/watchers.module';
import SplashModule from './splash/splash.module';

const forbiddenSassStates = ['settings.mail', 'settings.database_sync', 'settings.proxy', 'settings.httpConfig', 'settings.set_license', 'settings.system_monitoring', 'settings.support_page', 'settings.general', 'settings.ha', 'settings.failure_messages','settings.system_logs','settings.system_licenses'];

angular.module('xray-ui.states', [
    XrayLogin.name,
    // SplashModule.name,
    // CreateUser.name,
    // BaseState.name,
     WatchersModule.name,
    // ScanModule.name,
    // AlertsModule.name,
     ComponentsModule.name,
    SettingsModule.name,
    // UserProfileModule.name,
    //notFound404.name,
    //Forbidden403.name,
    //ServerError.name,
    ReportsModule.name,
    componentDetailsNew.name,
    //NotFoundModule.name,
    PoliciesModule.name,
    'xray-ui.services',
    'xray-ui.dao',
    'cfp.hotkeys',
    'ui.router'
]).run(changeStateHook);

function changeStateHook($timeout, $rootScope, $q, $state, XRayUIState, JFrogEventBus, XrayUser, InitialConfigurationModal,
                         XRayUIPermissions, XRayUIStorage, $location) {

    $rootScope.$on('$locationChangeStart', (e, newUrl) => {
        if (XRayUIState.getState('confirmDiscardModalOpen')) {
            e.preventDefault();
        }
    });

    $rootScope.$on('$stateChangeStart', (e, toState, toParams, fromState, fromParams) => {

        //console.log(fromState.name + ' -> ' + toState.name);

       /* if (XRayUIState.getState('isSaas') && forbiddenSassStates.indexOf(toState.name) > -1) {
            $state.go('home');
            e.preventDefault();
            return;
        }*/

        let newState = toState.name.split('.')[0];
        //console.log('Need to Verify read permission for ', newState)
        //TODO: Refactor Boolean to be dynamic according to 'to' state
        let isXray = false;
        if(isXray){
            XRayUIPermissions.hasViewPermission(newState);

            if (fromState.name !== toState.name) {
                InitialConfigurationModal.isSystemConfigured().then((configured) => {
                    if (!configured && !!User.getCurrent() && toState.name !== 'login') {


                        InitialConfigurationModal.show();
                    }
                });
            }


            if (fromState.name && toState.name && fromState.name != toState.name) {
                JFrogEventBus.dispatch(EVENTS.CANCEL_SPINNER);
            }


            if (toState.name.startsWith('settings.') && (!User.getCurrent() || !User.getCurrent().admin)) {
                e.preventDefault();
                return;
            }

            else if (!XRayUIState.getState('confirmDiscardModalOpen')) {

                if (XRayUIState.getState('ignoreConfirmationModal')) {
                    XRayUIState.removeState('ignoreConfirmationModal');
                    $state.go(toState.name, toParams);
                } else {
                    checkDiscardConfirmation($q, e).then(() => {
                        $state.go(toState.name, toParams);
                    });
                }
            }
            else {
                e.preventDefault();
                return;
            }


            if (!e.defaultPrevented) {
                JFrogEventBus.dispatch(EVENTS.CLOSE_MODAL);
            }
        }

    });
}


function checkDiscardConfirmation($q, e) {

    let defer = $q.defer();
    let forms = $('form');
    let changeDiscovered = false;
    for (let i = 0; i < forms.length; i++) {
        let form = forms[i];
        let controller = angular.element(form).controller();
        if (controller && controller._$modelSaver$_ && controller._$modelSaver$_.confirmOnLeave && !controller._$modelSaver$_.isModelSaved()) {
            changeDiscovered = true;

            controller._$modelSaver$_.ask().then(() => {
                controller._$modelSaver$_.confirmOnLeave = false;
                defer.resolve();
            });

            break;
        }
    }

    if (!changeDiscovered && !e) {
        defer.resolve();
    }
    else if (changeDiscovered && e) {
        e.preventDefault();
    }

    return defer.promise;

}



// WEBPACK FOOTER //
// ./modules/xray/states/xray-ui.states.module.js